import React, { useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { API, graphqlOperation } from 'aws-amplify';
import { ButtonTemplate } from '../button/button-template';
import { DeleteUser } from '../../lib/graphql-command/user-command';

const useStyle = makeStyles(theme => ({
    title: {
        padding: '0 5px'
    },
    closeButton: {
        position: 'absolute',
        color: theme.palette.grey[500]
    },
}))


export const DeleteUserDialog = ({open, setOpen, user, getListUser}) => {
    const [disabled, setDisabled] = useState(false);
    
    const handleDelete = () => {
        setDisabled(true)
        API.graphql(graphqlOperation(DeleteUser, {UserID: user.UserID}))
        .then(result => {
            setDisabled(false)
            setOpen(false)
            getListUser();
            
        })
        .catch(err => console.log(err))
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
            <DialogTitle className={useStyle().title}>
                <Grid container direction='row' justify='flex-end'>
                    <Grid item>
                        <IconButton onClick={() => setOpen(false)}>
                            <CloseIcon className={useStyle().closeButton} />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Box py={5} textAlign='center'>
                    Are you sure you want to delete this account?
                </Box>
            </DialogContent>
            <DialogActions>
                <Grid container direction='row' justify='center' spacing={5}>
                    <Grid item>
                        <Box pb={5}>
                            <ButtonTemplate
                                variant='outlined'
                                color='primary'
                                size='small'
                                changetextcolor='#fff'
                                borderradius='5px'
                                onClick={() => setOpen(false)}
                            >Cancel</ButtonTemplate>
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box pb={5}>
                            <ButtonTemplate
                                variant='contained'
                                color='primary'
                                size='small'
                                changetextcolor='#fff'
                                borderradius='5px'
                                onClick={handleDelete}
                                disabled={disabled}
                            >Delete</ButtonTemplate>
                        </Box>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}